module.exports = __webpack_public_path__ + "static/media/results-sample.6d5506cb.png";